"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var SortProviderNoUrl_1 = require("../SortProviderNoUrl");
var DatasourceWebclientOrderField;
(function (DatasourceWebclientOrderField) {
    DatasourceWebclientOrderField["connectedWorkbooksCount"] = "connectedWorkbooksCount";
    DatasourceWebclientOrderField["hasalert"] = "hasAlert";
    DatasourceWebclientOrderField["lastRefreshedAt"] = "lastRefreshedAt";
    DatasourceWebclientOrderField["name"] = "name";
    DatasourceWebclientOrderField["ownerName"] = "ownerName";
    DatasourceWebclientOrderField["projectName"] = "projectName";
})(DatasourceWebclientOrderField = exports.DatasourceWebclientOrderField || (exports.DatasourceWebclientOrderField = {}));
exports.ConnectToDatasourcesDefaultDirections = (_a = {},
    _a[DatasourceWebclientOrderField.connectedWorkbooksCount] = globalTypes_1.OrderDirection.DESC,
    _a[DatasourceWebclientOrderField.lastRefreshedAt] = globalTypes_1.OrderDirection.DESC,
    _a[DatasourceWebclientOrderField.name] = globalTypes_1.OrderDirection.ASC,
    _a[DatasourceWebclientOrderField.ownerName] = globalTypes_1.OrderDirection.ASC,
    _a[DatasourceWebclientOrderField.projectName] = globalTypes_1.OrderDirection.ASC,
    _a);
exports.ConnectToDatasourcesDefaultSortField = DatasourceWebclientOrderField.connectedWorkbooksCount;
function ConnectToDatasourcesGridSortProvider(props) {
    return (React.createElement(SortProviderNoUrl_1.SortProviderNoUrl, { key: 'ConnectToDatasources', defaultField: exports.ConnectToDatasourcesDefaultSortField, validOrderFieldsWithDefaultDirections: exports.ConnectToDatasourcesDefaultDirections }, props.children));
}
exports.ConnectToDatasourcesGridSortProvider = ConnectToDatasourcesGridSortProvider;
//# sourceMappingURL=ConnectToDatasourcesSortProvider.js.map